export default {"src":"/_next/static/media/ico-three-dots.cfb4f15c.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};